import type { FC, ReactNode } from 'react'

// Shown while the game code downloads, and as the page content for search engines.
const LoadingScreen: FC = (): ReactNode => {
    return (
        <div className='fixed inset-0 flex flex-col items-center justify-center overflow-hidden [background:radial-gradient(circle_at_70%_25%,#2a1d6b,transparent_55%),radial-gradient(circle_at_20%_85%,#0e3a5c,transparent_50%),#070c24] px-6 text-center text-white'>
            <h1 className='font-heading text-4xl font-black tracking-tight uppercase sm:text-6xl'>
                <span className='neon-text'>AI Smart </span>
                <span className='bg-gradient-to-r from-cyan-300 via-electric-light to-violet-400 bg-clip-text text-transparent'>Campus</span>
            </h1>
            <p className='mt-3 font-heading text-xs font-bold tracking-[0.32em] text-violet-200 uppercase sm:text-sm'>The Generative AI Adventure</p>
            <p className='mt-6 max-w-lg text-sm leading-relaxed text-slate-300 sm:text-base'>
                An interactive 3D campus where university students learn what generative AI is, how to use it for study, the ethics
                behind it and how to spot its risks, guided by AIX the robot.
            </p>
            <div className='mt-8 h-1.5 w-56 overflow-hidden rounded-full bg-white/10' role='progressbar' aria-label="Loading the campus">
                <div className='h-full w-1/3 animate-sweep rounded-full bg-gradient-to-r from-cyan-300 to-violet-400' />
            </div>
            <p className='mt-3 text-xs text-slate-400'>Loading the campus</p>
            <noscript>
                <p className='mt-6 max-w-md text-sm text-amber-200'>AI Smart Campus needs JavaScript to run. Please turn it on in your browser settings and reload the page.</p>
            </noscript>
        </div>
    )
}

export default LoadingScreen
